<app-table-card-layout
    #cardLayout
    title="Recent documents"
    [isLoading]="isLoaded"
    [failed]="dmsFailed"
    [hasData]="allDocuments().length > 0"
    [noDataMessage]="globalMessages.noDataAvailabelMsg"
    [errorMessage]="globalMessages.serviceMsgError"
    (retry)="reloadDocuments()"
>
    @if (!isThirdParty) {
    <div headerActions class="d-flex flex-row align-items-center psic-gap-8" [class.d-none]="isLoaded">
        <!-- <lib-button
            [buttonType]="'borderless'"
            (click)="reloadDocuments(); $event.stopPropagation()"
            [buttonTheme]="'secondary'"
            [libIcon]="'reload'"
            [buttonText]="'Reload'"
            [buttonSize]="'small'"
        >
        </lib-button> -->
        <lib-button
            (click)="goToDocHub(); $event.stopPropagation()"
            [buttonTheme]="'secondary'"
            [libIcon]="'new-window-open'"
            [buttonText]="'Go to Dochub'"
            [buttonSize]="'small'"
        >
        </lib-button>
    </div>
    } @if(documents().length > 0){
    <div [class.d-none]="isLoaded" class="d-flex flex-column psic-gap-6">
        @if (!cardLayout.isCompact()) {
        <!-- Standard table view -->
        <div class="table-container" [class.table-container--collapsed]="!showAll() && allDocuments().length > 6">
            <table>
                <thead>
                    <tr class="disclaimer-bold">
                        <th style="width: 20%">File name</th>
                        <th style="width: 20%">Category</th>
                        <th style="width: 40%">Type</th>
                        <th style="width: 15%">Send date</th>
                        <th style="width: 5%" class="send-by-header">Send by</th>
                    </tr>
                </thead>
                <tbody>
                    @for (doc of allDocuments(); track doc.attachmentDocId || doc.fileName; let i = $index) {
                    <tr [class.active]="selectedRow === i">
                        <td class="file-name disclaimer-bold p1-50-color">
                            <span
                                class="clickable-filename"
                                (click)="viewDocument(doc); selectRow(i); $event.stopPropagation()"
                            >
                                {{ doc.fileName }}
                            </span>
                        </td>
                        <td class="disclaimer">{{ doc.category }}</td>
                        <td class="disclaimer type">{{ doc.type }}</td>
                        <td class="disclaimer">{{ doc.sendDate }}</td>
                        <td class="actions send-by-data d-flex align-items-center justify-content-center">
                            <div
                                [matMenuTriggerFor]="menu"
                                #t="matMenuTrigger"
                                (click)="selectRow(i); $event.stopPropagation()"
                                class="d-flex align-items-center justify-content-center"
                                style="height: fit-content"
                            >
                                <mat-icon
                                    [ngClass]="t.menuOpen ? 'mat-button-icon-open' : 'mat-button-icon'"
                                    [svgIcon]="t.menuOpen ? 'close' : 'more-vertical'"
                                >
                                </mat-icon>
                            </div>
                            <mat-menu #menu="matMenu" class="actions">
                                <div class="actions-menu psic-px-2">
                                    <button
                                        class="actions-menu-button"
                                        mat-menu-item
                                        (click)="sendDocumentBySMS(doc, menu); $event.stopPropagation()"
                                    >
                                        <div class="d-flex align-items-center">
                                            <mat-icon class="actions-menu-button-icon" [svgIcon]="'comment-alt-check'">
                                            </mat-icon>
                                            <span class="caption">Send via SMS</span>
                                        </div>
                                    </button>
                                    <button
                                        class="actions-menu-button"
                                        mat-menu-item
                                        (click)="sendDocumentByEmail(doc, menu); $event.stopPropagation()"
                                    >
                                        <div class="d-flex align-items-center">
                                            <mat-icon class="actions-menu-button-icon" [svgIcon]="'send-email'">
                                            </mat-icon>
                                            <span class="caption">Send by email</span>
                                        </div>
                                    </button>
                                </div>
                            </mat-menu>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="5" class="text-center disclaimer">No recent documents available.</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        } @else {
        <!-- Compact 2-column key-value view -->
        <div
            class="compact-list d-flex flex-column psic-gap-6"
            [class.compact-list--collapsed]="!showAll() && allDocuments().length > 6"
        >
            @for (doc of allDocuments(); track doc.attachmentDocId || doc.fileName; let i = $index) {
            <div
                class="compact-card"
                [class.active]="selectedRow === i"
                (click)="viewDocument(doc); selectRow(i); $event.stopPropagation()"
            >
                <table class="compact-table">
                    <tbody class="d-flex flex-column psic-gap-3 psic-py-3">
                        <tr>
                            <td class="compact-label disclaimer-bold">File name</td>
                            <td class="compact-value disclaimer-bold p1-50-color">{{ doc.fileName }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Category</td>
                            <td class="compact-value disclaimer">{{ doc.category }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Type</td>
                            <td class="compact-value disclaimer">{{ doc.type }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Send date</td>
                            <td class="compact-value disclaimer">{{ doc.sendDate }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Actions</td>
                            <td class="compact-value">
                                <div
                                    [matMenuTriggerFor]="menu"
                                    #t="matMenuTrigger"
                                    (click)="selectRow(i); $event.stopPropagation()"
                                    class="d-flex align-items-center justify-content-end"
                                    style="height: fit-content"
                                >
                                    <mat-icon
                                        [ngClass]="t.menuOpen ? 'mat-button-icon-open' : 'mat-button-icon'"
                                        [svgIcon]="t.menuOpen ? 'close' : 'more-vertical'"
                                    >
                                    </mat-icon>
                                </div>
                                <mat-menu #menu="matMenu" class="actions">
                                    <div class="actions-menu psic-px-2">
                                        <button
                                            class="actions-menu-button"
                                            mat-menu-item
                                            (click)="sendDocumentBySMS(doc, menu); $event.stopPropagation()"
                                        >
                                            <div class="d-flex align-items-center">
                                                <mat-icon
                                                    class="actions-menu-button-icon"
                                                    [svgIcon]="'comment-alt-check'"
                                                >
                                                </mat-icon>
                                                <span class="caption">Send via SMS</span>
                                            </div>
                                        </button>
                                        <button
                                            class="actions-menu-button"
                                            mat-menu-item
                                            (click)="sendDocumentByEmail(doc, menu); $event.stopPropagation()"
                                        >
                                            <div class="d-flex align-items-center">
                                                <mat-icon class="actions-menu-button-icon" [svgIcon]="'send-email'">
                                                </mat-icon>
                                                <span class="caption">Send by email</span>
                                            </div>
                                        </button>
                                    </div>
                                </mat-menu>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            } @empty {
            <div class="text-center disclaimer psic-py-4">No recent documents available.</div>
            }
        </div>
        }

        <div class="d-flex flex-row justify-content-center align-items-center psic-pb-3 w-100">
            @if (!showAll() && allDocuments().length > 6) {
            <lib-button
                (click)="loadMore()"
                [disabled]="false"
                [buttonType]="'borderless'"
                [buttonSize]="'medium'"
                [buttonText]="'Show more'"
                [libIcon]="'chevron-down'"
            ></lib-button>
            } @else if (showAll() && allDocuments().length > 6) {
            <lib-button
                (click)="showLess()"
                [disabled]="false"
                [buttonType]="'borderless'"
                [buttonSize]="'medium'"
                [buttonText]="'Show less'"
                [libIcon]="'chevron-up'"
            ></lib-button>
            }
        </div>
    </div>
    }
</app-table-card-layout>
